// src/pages/RedirectAfterLogin.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { redirectToLogin } from "./utils/authRedirect";

const RedirectAfterLogin = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    let isActive = true;

    const validateSession = async () => {
      const authenticatedUser = await checkAuth();

      if (!isActive) {
        return;
      }

      if (authenticatedUser) {
        navigate("/functionalpagelogin", { replace: true });
        return;
      }

      redirectToLogin();
    };

    validateSession();

    return () => {
      isActive = false;
    };
  }, [checkAuth, navigate]);

  return null;
};

export default RedirectAfterLogin;
